import { render, staticRenderFns } from "./SeverityBadge.vue?vue&type=template&id=5e0d3d18&scoped=true"
import script from "./SeverityBadge.vue?vue&type=script&lang=js"
export * from "./SeverityBadge.vue?vue&type=script&lang=js"
import style0 from "./SeverityBadge.vue?vue&type=style&index=0&id=5e0d3d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d3d18",
  null
  
)

export default component.exports